export default "__VITE_ASSET__DYoVynNO__"